class FixedSidenav{
	constructor(fixer = 0,has_element = 0) {

		this.has_element = has_element;
		if(this.has_element > 0){
			this.fix = $('.js-fixed_sidemenu');
			this.side = $('.js-fixed_sidemenu_wrap'), //サイドバーのID
			this.main = $('.js-fixed_sidemenu_base'), //固定する要素を収める範囲
			this.sideTop = this.side.offset().top,
			this.fixTop = this.fix.offset().top,
			this.mainTop = this.main.offset().top,
			this.fixer = fixer,
			this.w = $(window);
			this.has_element = true;

			this.sideHeight = this.side.outerHeight(true);

			if(this.w.height() < 1220){
				this.side.css({
					position:'absolute',
					bottom:'auto',
				});
			}
		}

		this.adjust = this.adjust.bind(this);
	}

	adjust(){
		let scrollTop = this.w.scrollTop();
		let footer = $("#footer");

		let fixTop = this.fix.css('position') === 'static' ? this.sideTop + this.fix.position().top : this.fixTop;
		let fixHeight = this.fix.outerHeight(true),
			mainHeight = this.main.outerHeight();
		if(scrollTop > this.sideTop){
			this.side.css({
				position: 'fixed',
				bottom:0,
			});

			// 動的にコンテンツが追加されてもいいように、常に計算する
			let footerTop = footer.offset().top - 120;
			let customTopPosition;
			if(scrollTop + this.sideHeight > footerTop){
				customTopPosition = footerTop - (scrollTop + this.sideHeight);
				this.side.css({position: "fixed", top:  customTopPosition + "px",bottom:'auto'});
			}else{
				this.side.css({position: "fixed", top: 0});
			}
		}else{
			this.side.css({
				position: 'absolute',
				bottom:'auto',
			});
		}
	}

	setBodyClass(){
		if(this.fix.length > 0){
			$('body').addClass('has_fixed_nav');
		}
	}

	exec(){
		if(this.has_element ){
			this.setBodyClass();

			this.w.on('scroll', function(){
				this.adjust();
			}.bind(this));

			this.w.on("load resize scroll", function(){
				if(window.innerWidth < 1240){
					this.side.css("left", -1 * this.w.scrollLeft());
				}else{
					this.side.css("left", 'auto');
				}
			}.bind(this));
		}
	}
}
module.exports = FixedSidenav;



// WEBPACK FOOTER //
// ./dev/js/scripts/FixedSidenav.js